import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders, HttpXsrfTokenExtractor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, finalize, tap, throwError } from 'rxjs';

import { AuthenticationService } from '../services/auth/authentication.service';
import { CookieService } from 'ngx-cookie-service';
import { LoaderService } from '../services/loader.service';
import { Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';
import { CommonService } from '../services/common.service';
import { LocalDataService } from '../services/local-data.service';
import { Constants } from '../constants';
import { TwilioHelperService } from '../services/twilio-helpers.service';

@Injectable()
export class CCCInterceptor implements HttpInterceptor {
    is4014TokenVerify = false;
    #headerName = 'X-XSRF-TOKEN';
    constructor(
        private localCookies: CookieService, private loaderService: LoaderService,
        private tokenService: HttpXsrfTokenExtractor, private router: Router,
        private notificationService: NotificationService, 
        private _twilioService: TwilioHelperService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.router.url.indexOf('screenpop') == -1 && this.router.url.indexOf('otislinepbx') == -1 && this.router.url.indexOf('login') == -1  && this.router.url.indexOf('ongoing-elevator-call') == -1 && request.url.indexOf('sec-api/get-worker-report') == -1) {
            this.loaderService.showLoader();
        }
        //////XSRF///////
        const token = this.tokenService.getToken();
        // Be careful not to overwrite an existing header of the same name.
        if (token !== null && !request.headers.has(this.#headerName)) {
            request = request.clone({
                headers: request.headers.set(this.#headerName, token),
            });
        }
        //////JWT///////
        // add auth header with jwt if user is logged in and request is to the api url
        const logintoken = this.localCookies.get('CCApp-token');
        const Countryid = this.localCookies.get('CCApp-countryID');
        const Displayelevatorid = this.localCookies.get('lastElevatorId');
        const Emailid = this.localCookies.get('CCApp-emailid');
        const Isongoingcall = this.localCookies.get('CCApp-isOngoingCall');
        const XsrfToken = this.localCookies.get('XSRF-TOKEN');
        const userId = this.localCookies.get('CCApp-userID');
        const workerSid = this.localCookies.get('CCApp-sId');
        // TODO : elevatorID should be added to headers only if it is not null
        const elevatorID = this.localCookies.get('CCApp-elevatorID');

        if (logintoken) { }
        request = request.clone({
          headers: request.headers.
            set('token', logintoken).
            set('Countryid', Countryid)
            .set('Displayelevatorid', Displayelevatorid)
            .set('Emailid', Emailid)
            .set('Isongoingcall', Isongoingcall)
            .set('Xsrf-Token', XsrfToken)
            .set('userId', userId)
            .set('workerSid', workerSid)
            .set('elevatorID', elevatorID)
        });
    
        return next.handle(request).pipe(
          tap(response => {
            if (response instanceof HttpResponse) {
              if (this.router.url.indexOf('screenpop') == -1 && this.router.url.indexOf('otislinepbx') == -1 && this.router.url.indexOf('login') == -1  && request.url.indexOf('sec-api/get-worker-report') == -1) {
                  this.loaderService.hideLoader();
              }
            }
          }),
          catchError((err: any) => {            
            if (err instanceof HttpErrorResponse) {
              if (this.router.url.indexOf('screenpop') == -1 && this.router.url.indexOf('otislinepbx') == -1 && this.router.url.indexOf('login') == -1  && request.url.indexOf('sec-api/get-worker-report') == -1) {
                this.loaderService.hideLoader();
              }
              this.executeFunction(err)
              if (err.status == 400) {
                this.errorHandler(err)
              } else {
                this.executeFunction(err.status);
              }
              this.handleError(err);
            }
            return throwError(() => {
              new Error(err);
            });
          }));
      }
      handleError(err: any) {
        const error = err.error.message || err.statusText;
        //this.authenticationService.logout();
        if(err.status === 401 || err.status === 404){
          return this.executeFunction(err.status);
        } else if(err.status === 0){
          this.notificationService.errorMessage("Not able to communicate with server, Please wait 10 sec.", err.status);
        }
      return false;
    }
    errorHandler(err: any) {
      if (err.error != null) {
        if (err.error.message == "Bad Request") {
          //// Redirect to login page.
          // $rootScope.$emit("redirectToInvalidAccessPage");
          this.router.navigate(['/error-page'], { state: { error: err.status, message: err } })
        }
        else {
          return this.executeFunction(err.status);
        }
      } else {
        return this.executeFunction(err.status);
      }
    }
    // Unauthorized access
  executeFunction(rejection: any) {
    if (rejection.status === 401 || rejection.status === 403) { //|| rejection.status === 404
      if (rejection.url.includes("/sec-api/token-verification") && this.is4014TokenVerify == false) {
        this.is4014TokenVerify = true;
      } else {
        this.is4014TokenVerify = false;
        this.localCookies.delete('CCApp-token');
        this.localCookies.delete('CCApp-emailid');

        //// Redirect to login page.
        this._twilioService.redirectToLogin(rejection.status);
      }
    }
  }
    }